"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertUniqueDateFormat = convertUniqueDateFormat;
function convertUniqueDateFormat(dateValue) {
  const date = new Date(dateValue);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const year = date.getFullYear().toString().substr(-2);
  const month = date.getMonth();
  let dt = date.getDate();
  const hh = date.getHours();
  let mm = date.getMinutes();
  if (mm < 10) {
    mm = "0".concat(mm);
  }
  if (dt < 10) {
    dt = "0".concat(dt);
  }
  const hhmm = "".concat(hh, ":").concat(mm);
  const fullDate = "".concat(dt, "-").concat(monthNames[month], "-").concat(year, ": ").concat(hhmm);
  return fullDate;
}